import { useSearchParams } from "react-router";

import { RegistrarRecordHeader } from "@/components/registrar/RegistrarRecordHeader";
import type { Course, CourseStatus } from "@/lib/api/courses";
import { isHistoricalTerm } from "@/lib/term-state";

const STATUS_LABEL: Record<CourseStatus, string> = {
  draft: "Draft",
  published: "Published",
  archived: "Archived",
};

/** The term, closed when it is over, then the CRN once it is issued. */
function sectionMeta(course: Course): string {
  const term = course.semester_name
    ? `${course.semester_name}${isHistoricalTerm(course.semester_status) ? ", closed" : ""}`
    : "No term";
  return course.crn ? `${term} · CRN ${course.crn}` : term;
}

/** The course record's identity: the section under the way back to the list, and its one status. */
export function RegistrarCourseHeader({ course, listHref }: { course?: Course; listHref: string }) {
  const [searchParams] = useSearchParams();
  const recordView = !searchParams.get("view") || searchParams.get("view") === "record";
  return (
    <RegistrarRecordHeader
      listHref={listHref}
      listLabel="All sections"
      eyebrow="Course section"
      title={course ? recordView ? "Section record" : `${course.code} · ${course.title}` : undefined}
      meta={course ? recordView ? course.crn ? `CRN ${course.crn}` : undefined : sectionMeta(course) : undefined}
      status={course && <span className="text-meta text-muted-foreground">{STATUS_LABEL[course.status]}</span>}
    />
  );
}
